import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Package, Store, ShoppingCart, Users, FolderTree, Settings, UserCog, KeyRound, ScrollText, Boxes, LayoutGrid, Tags, SlidersHorizontal, FileText,
} from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { LoadingState } from "@/components/common/States";

const NAV = [
  [LayoutDashboard, "Dashboard", "/admin"],
  [Users, "Users", "/admin/users"],
  [Store, "Vendors", "/admin/vendors"],
  [UserCog, "Staff", "/admin/staff"],
  [KeyRound, "Roles", "/admin/roles"],
  [ScrollText, "Audit Logs", "/admin/audit"],
  [Package, "Products", "/admin/products"],
  [FolderTree, "Categories", "/admin/categories"],
  [Boxes, "Inventory", "/admin/inventory"],
  [LayoutGrid, "Homepage", "/admin/homepage"],
  [Tags, "Attributes", "/admin/attributes"],
  [SlidersHorizontal, "Catalogue Settings", "/admin/catalog-settings"],
  [ShoppingCart, "Orders", "/admin/orders"],
  [FileText, "RFQs", "/admin/rfqs"],
  [Settings, "Settings", "/admin/settings"],
];

export default function AdminLayout() {
  const { user } = useStore();
  const navigate = useNavigate();

  if (user === null) return <LoadingState label="Loading admin..." />;
  if (user === false || !["admin", "staff"].includes(user.role)) {
    return (
      <div className="max-w-lg mx-auto px-4 py-24 text-center">
        <h1 className="text-2xl font-serif font-bold text-stone-900">Admin Access Required</h1>
        <p className="mt-2 text-stone-600">Please sign in with an administrator account.</p>
        <button onClick={() => navigate("/login")} className="mt-4 rounded-full bg-primary text-primary-foreground font-semibold px-6 py-2.5">Go to Login</button>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="grid lg:grid-cols-[240px_1fr] gap-8">
        <aside>
          <div className="rounded-xl border border-border bg-card p-3 lg:sticky lg:top-40">
            <div className="px-3 py-2 mb-1">
              <div className="text-xs text-stone-400">Internal</div>
              <div className="font-serif font-bold text-secondary">Shri Vrindavan Shop Admin</div>
            </div>
            <nav className="flex lg:flex-col gap-1 overflow-x-auto hide-scrollbar">
              {NAV.map(([Icon, label, to]) => (
                <NavLink
                  key={to}
                  to={to}
                  end={to === "/admin"}
                  data-testid={`admin-nav-${label.toLowerCase().replace(/ /g, "-")}`}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium whitespace-nowrap ${isActive ? "bg-secondary text-white" : "text-stone-600 hover:bg-muted"}`
                  }
                >
                  <Icon size={17} /> {label}
                </NavLink>
              ))}
            </nav>
          </div>
        </aside>
        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
